<template>
    <v-card>
        <loading-component v-model="loading"></loading-component>
        <v-card-title>
            <b>Events</b>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    @keyup.enter="getData"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialog = true">New</v-btn>
        </v-card-title>
        <v-data-table :headers="headers"
                      :items="data"
                      :pagination.sync="pagination"
                      :total-items="totalItems"
                      :loading="loading"
        >
            <template v-slot:items="props">
                <tr :style="getStyle(props.item)">
                    <td class="text-xs-center">{{ props.item.id }}</td>
                    <td class="text-xs-center"
                        :style="{color: isCredit(props.item) ? 'green' : 'red'}">
                        <b>{{ props.item.type.name }}</b>
                    </td>
                    <td class="text-xs-center">{{ props.item.user.first_name + ' ' + props.item.user.last_name }}</td>
                    <td class="text-xs-center">{{ (isCredit(props.item) ? '' : '-') + props.item.amount }}
                    </td>
                    <td class="text-xs-center">{{ getApproveUserValue(props.item) }}</td>
                    <td class="text-xs-center">{{ props.item.bill_details ? props.item.bill_details : '-' }}</td>
                    <td class="text-xs-center">{{ props.item.created_at }}</td>
                </tr>
            </template>
            <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <v-dialog width="80%" v-model="dialog">
            <v-card>
                <h1 style="text-align:center;padding-top: 15px"
                    :style="{color: model.type ? ((model.type.name==='CREDIT' || model.type.name==='CREDIT_CAPTAIN_WALLET') ? 'green' : 'red') : ''}">
                    New
                    Transaction</h1>
                <v-card-text>
                    <v-container>
                        <v-form ref="form" v-model="valid">
                            <v-select label="Type" type="number" :items="event_types" return-object
                                      item-text="name" v-model="model.type"></v-select>
                            <v-alert v-if="model.type" :value="true" type="warning" style="margin-bottom: 10px">
                                <span v-if="model.type.name === 'DEBIT_CAPTAIN_WALLET'">
                                    <b>Note: </b> You are giving money to selected captain
                                </span>
                                <span v-else-if="model.type.name === 'CREDIT_CAPTAIN_WALLET'">
                                    <b>Note: </b> You are getting money from selected captain
                                </span>
                                <span v-if="model.type.name === 'DEBIT'">
                                    <b>Note: </b> You are spending money from cash
                                </span>
                                <span v-else-if="model.type.name === 'CREDIT'">
                                    <b>Note: </b> You are adding money to cash
                                </span>
                            </v-alert>
                            <div v-if="model.type && (model.type.name === 'DEBIT_CAPTAIN_WALLET' || model.type.name === 'CREDIT_CAPTAIN_WALLET')">
                                <choose-captains-multi label="Choose Captain" :multi="false"
                                                       v-model="model.captain_id"></choose-captains-multi>
                                <v-alert v-if="model.captain_id && model.checker" :value="true" type="warning"
                                         style="margin-bottom: 10px">
                                    <div>
                                        <p><b>Current balance:</b><span
                                                :style="[model.closing >= 0 ? {color:'red'} : {color:'green'}]"> {{model.closing}} S.P</span>
                                        </p>
                                        <p>
                                            <b>Balance after apply requested transaction:</b>
                                            <span :style="[after_apply_balance + model.closing >= 0 ? {color:'red'} : {color:'green'}]">
                                                {{after_apply_balance}} S.P
                                            </span>
                                        </p>
                                        <p style="color: red"
                                           v-if="model.type.name === 'DEBIT_CAPTAIN_WALLET'&& model.closing < model.amount">
                                            <b>You cannot give requested amount for this captain</b>
                                        </p>
                                    </div>
                                </v-alert>
                                <v-alert v-else-if="model.captain_id" :value="true" type="warning"
                                         style="margin-bottom: 10px">
                                    You cannot do transactions for this account, checker failed please contact tech team
                                </v-alert>
                            </div>
                            <v-text-field v-if="model.type" label="Amount" type="number" :rules="requiredRules"
                                          v-model="model.amount"></v-text-field>
                            <v-textarea label="Bill details (Optional)"
                                        v-if="model.type && (model.type.name==='DEBIT' || model.type.name === 'CREDIT')"
                                        v-model="model.bill_details"></v-textarea>
                        </v-form>
                        <v-alert v-if="model.type" :value="true" type="warning" style="margin-bottom: 10px">
                            <b :style="{color: isCredit(model) ? 'green' : 'red'}">
                                {{isCredit(model) ?
                                'Crediting' :
                                'Debiting'}}</b> Transaction, you're not able to rollback this
                            transaction, make sure that all is right.
                        </v-alert>
                        <v-btn color="primary" style="margin: auto;width: 100%" @click="save">COMMIT</v-btn>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";

    export default {
        name: "Events",
        components: {ChooseCaptainsMulti, LoadingComponent},
        props: {
            cash_register_id: {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                valid: false,
                dialog: false,
                tab: 'credit',
                model: {
                    amount: null,
                    bill_details: '',
                    type: null
                },
                headers: [
                    {text: '#', value: 'id', align: 'center'},
                    {text: 'Type', value: 'type', align: 'center'},
                    {text: 'User', value: 'user', align: 'center', sortable: false},
                    {text: 'Amount', value: 'amount', align: 'center'},
                    {text: 'Approve User', value: 'approve_user', align: 'center'},
                    {text: 'Bill details', value: 'bill_details', align: 'center'},
                    {text: 'Created At', value: 'created_at', align: 'center'}
                ],
                requiredRules: [
                    v => v !== null && v !== undefined && Number.isInteger(parseInt(v)) && v > 0 || 'Must be integer greater than 0'
                ],
                data: [],
                loading: false,
                search: '',
                totalItems: 0,
                pagination: {
                    rowsPerPage: 10,
                    rowsPerPageItems: [5, 10, 15, 25, 100]
                },
                event_types: []
            };
        },
        computed: {
            after_apply_balance() {
                if (this.model.type && this.model.closing) {
                    return this.model.closing + this.model.amount * (this.model.type.name === 'CREDIT_CAPTAIN_WALLET' ? 1 : -1)
                }
                return 0;
            }
        },
        watch: {
            pagination: {
                handler() {
                    this.getData();
                },
                deep: true
            },
            model: {
                handler(value) {
                    if (value.captain_id) {
                        this.axios.get(`captain/${value.captain_id}/base_balance`)
                            .then(res => {
                                this.$set(this.model, 'closing', Number.parseInt(res.data.data.closing));
                                this.$set(this.model, 'checker', res.data.data.checker);
                            })
                    }
                },
                deep: true
            },
        },
        mounted() {
            this.axios.get('cash_register_event_types')
                .then(res => this.event_types = res.data.data)
                .catch(err => console.log(err.message));
            this.getData();
        },
        methods: {
            isCredit(event) {
                return event.type.name === 'CREDIT' || event.type.name === 'CREDIT_CAPTAIN_WALLET';
            },
            getStyle(item) {
                return item.entry_id ? null : {'background-color': 'lightcoral'};
            },
            getApproveUserValue(item) {
                if (item.approve_user) {
                    return item.entry_id ? `Approved by  ${item.approve_user.first_name}  ${item.approve_user.last_name}` : 'Rejected';
                }
                return item.entry_id ? 'No approve required' : 'Pending';
            },
            getData() {
                this.loading = true;
                const params = new URLSearchParams();
                params.append('page', this.pagination.page);
                params.append("perPage", String(this.pagination.rowsPerPage));
                params.append("search", String(this.search));
                this.axios.get(`cash_registers/${this.cash_register_id}/events`, {params})
                    .then(res => {
                        this.data = res.data.data.data;
                        this.totalItems = res.data.data.total;
                        this.pagination.rowsPerPage = Number(res.data.data.per_page);
                        this.loading = false;
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            save() {
                if (!this.$refs.form.validate()) {
                    return;
                }
                this.loading = true;
                this.model.cash_register_event_type_id = this.model.type.id;
                this.axios.post(`cash_registers/${this.cash_register_id}/events`, this.model)
                    .then(res => {
                        if (res.data.data.entry_id) {
                            this.$emit('new_event', this.model.type.name, this.model.amount);
                        }
                        this.data.unshift(res.data.data);
                        this.$refs.form.reset();
                        this.model = {
                            amount: null,
                            bill_details: '',
                            type: null
                        };
                        this.dialog = false;
                    })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    })
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>
</style>